import React, { useEffect, useState } from "react"

import { Link } from "gatsby"
import { PlacesOfDeliveryList } from "components/page-components/Ausschreibungsdienste/landingpage-components"
import { sha256 } from "js-sha256"

const getDateFromSeconds = (seconds) =>
  new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(seconds * 1000))

const getDifferenceInDays = (seconds) => {
  const now = new Date()
  const now_without_time = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  )
  const ablaufDatum = new Date(seconds * 1000)
  const ablaufDatum_without_time = new Date(
    ablaufDatum.getFullYear(),
    ablaufDatum.getMonth(),
    ablaufDatum.getDate()
  )
  const difference = Math.round(
    (ablaufDatum_without_time.getTime() - now_without_time.getTime()) / 86400000
  )

  return difference
}

const getDeadlineString = (seconds) => {
  const differenceInDays = getDifferenceInDays(seconds)
  let result
  if (parseFloat(differenceInDays) < parseFloat(-1)) {
    result = `vor ${differenceInDays * -1} Tagen`
  } else if (differenceInDays === -1) {
    result = `gestern`
  } else if (differenceInDays === 0) {
    result = `heute`
  } else if (differenceInDays === 1) {
    result = `morgen`
  } else {
    result = `in ${differenceInDays} Tagen`
  }

  return result
}

export const DemosearchTenderHit = ({
  hit,
  is_bfz_module,
  no_flex,
  location,
}) => {
  const {
    ActBefore,
    buyer_string,
    CompletitionDeadline,
    places_of_delivery_struct,
    RefIDStringBI,
    ScopeOfServices,
    ServiceTypeName,
    TitelOnline,
    ZoneOfRequestName,
  } = hit

  const [scopeOfServicesOpen, setScopeOfServicesOpen] = useState(false)

  const disguised_string = sha256(buyer_string || "").slice(
    0,
    buyer_string ? Math.min(buyer_string.length, 35) : 24
  )
  const has_scope_of_servces = ScopeOfServices !== ""

  const openModal = () => {
    setScopeOfServicesOpen(true)
    const { scrollY } = window
    window.addEventListener("keydown", closeModalKeypress)
    Object.assign(document.body.style, {
      position: "fixed",
      top: `-${scrollY}px`,
      overflow: "hidden",
      width: "100vw",
    })
  }
  const closeModal = () => {
    setScopeOfServicesOpen(false)
    const scrollY = document.body.style.top
    window.removeEventListener("keydown", closeModalKeypress)
    Object.assign(document.body.style, {
      position: "",
      top: "",
      overflow: "unset",
      width: "",
    })
    window.scrollTo(0, parseInt(scrollY || "0") * -1)
  }

  const closeModalKeypress = (e) => {
    const { keyCode } = e
    if (keyCode === 27) {
      closeModal()
    }
  }

  useEffect(() => {
    return () => {
      Object.assign(document.body.style, {
        position: "",
        top: "",
        overflow: "unset",
        width: "",
      })
    }
  }, [])

  const card_content = [
    {
      title: `Ausführungsort${places_of_delivery_struct.length > 1 ? "e" : ""}`,
      content: (
        <PlacesOfDeliveryList
          {...{
            places_of_delivery_struct,
            initial_list_length: 2,
            location,
            text_color: "mitternachtsblau",
          }}
        />
      ),
    },
    {
      title: ZoneOfRequestName === "Privat / Gewerblich" ? "" : `Frist`,
      content:
        ZoneOfRequestName === "Privat / Gewerblich" ? (
          <div></div>
        ) : (
          <div className="has-text-mitternachtsblau">
            {!!ActBefore
              ? `${getDateFromSeconds(ActBefore)} / ${getDeadlineString(
                  ActBefore
                )}`
              : "-"}
          </div>
        ),
    },
    {
      title: `Auftraggeber`,
      content: (
        <span
          title="Um den Auftraggeber dieser Ausschreibung unverschlüsselt sehen zu können, buchen Sie bitte ein Paket der B_I ausschreibungsdatenbank"
          className="has-text-blurred-mitternachtsblau is-clipped"
        >
          {disguised_string}
        </span>
      ),
    },
    {
      title: `Zeitraum der Ausführung`,
      content: (
        <span className="has-text-mitternachtsblau">
          {CompletitionDeadline || "—"}
        </span>
      ),
    },
  ]

  return (
    <React.Fragment>
      <div
        className={`box p-5 ${
          no_flex
            ? " "
            : "is-flex is-flex-direction-column is-justify-content-space-between "
        } ${
          is_bfz_module
            ? "has-background-mitternachtsblau-10 is-bordered is-shadowless "
            : " "
        }`}
        style={{
          height: no_flex ? "auto" : "100%",
        }}
      >
        <div
          className={"has-text-mitternachtsblau pb-4"}
          style={{ fontSize: 18, position: "relative" }}
        >
          <div
            className="tag is-rounded is-mitternachtsblau-10"
            style={{ position: "absolute", right: 0 }}
          >
            ID: {RefIDStringBI}
          </div>
          <p className="mb-4 has-text-mitternachtsblau">
            {ServiceTypeName} | {ZoneOfRequestName}
          </p>
          <Link
            to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}`}
            className={`title is-4 has-text-mitternachtsblau`}
          >
            {TitelOnline}
          </Link>
        </div>

        <div className="columns is-multiline is-gapless mt-3 mb-0">
          {card_content.map(({ title, content }, index) => {
            return (
              <div
                className={`column is-${index % 2 === 0 ? "8" : "4"}`}
                key={"demotender-card-content-" + index}
              >
                <div className="mb-5">
                  <div className={`title has-text-evergabe is-8 mb-0`}>
                    {title}
                  </div>
                  <span style={{ fontSize: 18 }}>{content}</span>
                </div>
              </div>
            )
          })}
        </div>
        <hr className="is-mitternachtsblau-30 mt-0 is-slim" />

        <div className="columns mb-0">
          <div className="column is-half py-1 pl-0 px-0-mobile">
            {has_scope_of_servces ? (
              <button
                onClick={openModal}
                className="button is-fullwidth has-text-weight-bold is-mitternachtsblau is-outlined"
              >
                Leistungsbeschreibung lesen
              </button>
            ) : null}
          </div>
          <div className="column is-half py-1 pr-0 px-0-mobile">
            <Link
              to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}`}
              className="button is-fullwidth is-mitternachtsblau has-text-white"
            >
              Bekanntmachung öffnen
            </Link>
          </div>
        </div>
      </div>
      {has_scope_of_servces ? (
        <div className={`modal ${scopeOfServicesOpen ? "is-active" : ""}`}>
          <div
            className="modal-background"
            onClick={closeModal}
            role="button"
            tabIndex="0"
            onKeyDown={() => {}}
            aria-label="Close Success Modal"
          ></div>

          <div className="modal-content my-auto">
            <div
              className="box content"
              style={{
                maxWidth: 800,
                margin: "0 auto",
              }}
            >
              <p className="title is-4 my-2 has-text-mitternachtsblau">
                Leistungsbeschreibung
              </p>
              <hr className="is-mitternachtsblau-30 my-3 is-slim" />
              <p className="title is-4 my-5 pt-2 has-text-mitternachtsblau">
                {TitelOnline}
              </p>
              <p className="has-text-weight-bold mb-2 has-text-mitternachtsblau">
                Leistungsbeschreibung:
              </p>
              <div
                style={{
                  maxHeight: "50vh",
                  overflow: "auto",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                <p
                  className="has-text-mitternachtsblau"
                  dangerouslySetInnerHTML={{ __html: ScopeOfServices }}
                ></p>
              </div>

              <div className="mt-4">
                <div className="buttons">
                  <button
                    className="button is-sonnengelb ml-auto has-text-weight-bold"
                    aria-label="delete"
                    onClick={closeModal}
                  >
                    Schließen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  )
}
